import React from "react"
import * as styles from "./ScrollX.module.css"
import useDeviceType from "../../../../hooks/useDeviceType"

type CardsProps = {
  children: React.ReactElement
}

const ScrollX = ({ children }: CardsProps) => {
  const DeviceType = useDeviceType()

  if (DeviceType === "mobile") {
    return <div className={styles.container}>{children}</div>
  } else return children
}

export default ScrollX
